<h1 mat-dialog-title>
  Detalhes do serviço executado
</h1>

<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<div class="dialog-content">
  <app-form [campos]="camposDadosDetalhes" appearance="outline" #formDetalhes></app-form>
</div>
<!-- Ocultando botoes ate a nova regra -->
<div mat-dialog-actions align="end">
  <button
    mat-flat-button
    [disabled]="situacao !== 'Em análise'"
    (click)="onSubmit('R')">
    Reprovar
  </button>
  <button
    mat-flat-button
    [disabled]="situacao !== 'Em análise'"
    (click)="onSubmit('A')">
    Aprovar
  </button>
</div>
